const defaultState = {
    error: null,
    fetching: false,
    fetched: false
};

const postCreatePresignedUrl = (state = defaultState, action) => {
    switch (action.type) {
        case 'CREATE_PRESIGNED_URL_PENDING': {
            return {
                ...state, error: null, fetching: true
            };
        }
        case 'CREATE_PRESIGNED_URL_FULFILLED': {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: null,
                response: action.payload,
            };
        }
        case 'CREATE_PRESIGNED_URL_REJECTED': {
            return {
                ...state,
                fetching: false,
                fetched: false,
                error: action.payload
            };
        }
        default: {
            break;
        }
    }

    return state;
};

export default postCreatePresignedUrl;


// WEBPACK FOOTER //
// ./src/reducers/postCreatePresignedUrl.js